'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.currentOrganizationWatcher = currentOrganizationWatcher;
exports.fetchAccountsWatcher = fetchAccountsWatcher;
exports.uploadMediaToFBWatcher = uploadMediaToFBWatcher;
exports.getBlueprintsWatcher = getBlueprintsWatcher;
exports.deleteBlueprintWatcher = deleteBlueprintWatcher;
exports.getLayerSchemaWatcher = getLayerSchemaWatcher;
exports.postBlueprintWatcher = postBlueprintWatcher;
exports.putBlueprintWatcher = putBlueprintWatcher;
exports.postLayerTemplatesWatcher = postLayerTemplatesWatcher;
exports.getBlueprintWatcher = getBlueprintWatcher;
exports.postVariationWatcher = postVariationWatcher;
exports.postGenerateCSVWatcher = postGenerateCSVWatcher;
exports.getUserVariationWatcher = getUserVariationWatcher;
exports.postUserVariationWatcher = postUserVariationWatcher;
exports.getExportListWatcher = getExportListWatcher;
exports.putExportListWatcher = putExportListWatcher;
exports.duplicateBlueprintWatcher = duplicateBlueprintWatcher;
exports.addCustomMediaAssetWatcher = addCustomMediaAssetWatcher;
exports.startExportJobsPollingWatcher = startExportJobsPollingWatcher;

var _effects = require('redux-saga/effects');

var _redux = require('@adparlor-devops/js-anvil/redux');

var _constants = require('../constants');

var _executors = require('./executors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(currentOrganizationWatcher),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(fetchAccountsWatcher),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(uploadMediaToFBWatcher),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(getBlueprintsWatcher),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(deleteBlueprintWatcher),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(getLayerSchemaWatcher),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(postBlueprintWatcher),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(putBlueprintWatcher),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(postLayerTemplatesWatcher),
    _marked10 = /*#__PURE__*/_regenerator2.default.mark(getBlueprintWatcher),
    _marked11 = /*#__PURE__*/_regenerator2.default.mark(postVariationWatcher),
    _marked12 = /*#__PURE__*/_regenerator2.default.mark(postGenerateCSVWatcher),
    _marked13 = /*#__PURE__*/_regenerator2.default.mark(getUserVariationWatcher),
    _marked14 = /*#__PURE__*/_regenerator2.default.mark(postUserVariationWatcher),
    _marked15 = /*#__PURE__*/_regenerator2.default.mark(getExportListWatcher),
    _marked16 = /*#__PURE__*/_regenerator2.default.mark(putExportListWatcher),
    _marked17 = /*#__PURE__*/_regenerator2.default.mark(duplicateBlueprintWatcher),
    _marked18 = /*#__PURE__*/_regenerator2.default.mark(addCustomMediaAssetWatcher),
    _marked19 = /*#__PURE__*/_regenerator2.default.mark(startExportJobsPollingWatcher); // DEPRECATE/REFACTOR when fully moved to Unity

function currentOrganizationWatcher() {
  return _regenerator2.default.wrap(function currentOrganizationWatcher$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.takeLatest)(_redux.SESSION_CHANGE_ADVERTISER, _executors.currentOrganizationExecutor);

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function fetchAccountsWatcher() {
  return _regenerator2.default.wrap(function fetchAccountsWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_constants.MS_PAINT_FETCH_ACCOUNTS, _executors.fetchAccountsExecutor);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function uploadMediaToFBWatcher() {
  return _regenerator2.default.wrap(function uploadMediaToFBWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_constants.MS_PAINT_UPLOAD_MEDIA_TO_FB, _executors.uploadMediaToFBExecutor);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function getBlueprintsWatcher() {
  return _regenerator2.default.wrap(function getBlueprintsWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeLatest)([_constants.MS_PAINT_GET_BLUEPRINTS, _redux.SESSION_CHANGE_ADVERTISER], _executors.getBlueprintsExecutor);

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function deleteBlueprintWatcher() {
  return _regenerator2.default.wrap(function deleteBlueprintWatcher$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)(_constants.MS_PAINT_DELETE_BLUEPRINT, _executors.deleteBlueprintExecutor);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function getLayerSchemaWatcher() {
  return _regenerator2.default.wrap(function getLayerSchemaWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)(_constants.MS_PAINT_GET_LAYER_SCHEMA, _executors.getLayerSchemaExecutor);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function postBlueprintWatcher() {
  return _regenerator2.default.wrap(function postBlueprintWatcher$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)(_constants.MS_PAINT_POST_BLUEPRINT, _executors.postBlueprintExecutor);

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function putBlueprintWatcher() {
  return _regenerator2.default.wrap(function putBlueprintWatcher$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeLatest)(_constants.MS_PAINT_PUT_BLUEPRINT, _executors.putBlueprintExecutor);

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function postLayerTemplatesWatcher() {
  return _regenerator2.default.wrap(function postLayerTemplatesWatcher$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeLatest)(_constants.MS_PAINT_POST_LAYER_TEMPLATES, _executors.postLayerTemplatesExecutor);

        case 2:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function getBlueprintWatcher() {
  return _regenerator2.default.wrap(function getBlueprintWatcher$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeLatest)(_constants.MS_PAINT_GET_BLUEPRINT, _executors.getBlueprintExecutor);

        case 2:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function postVariationWatcher() {
  return _regenerator2.default.wrap(function postVariationWatcher$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeLatest)(_constants.MS_PAINT_POST_VARIATION, _executors.postVariationExecutor);

        case 2:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function postGenerateCSVWatcher() {
  return _regenerator2.default.wrap(function postGenerateCSVWatcher$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeLatest)(_constants.MS_PAINT_POST_GENERATE_CSV, _executors.postGenerateCSVExecutor);

        case 2:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function getUserVariationWatcher() {
  return _regenerator2.default.wrap(function getUserVariationWatcher$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeLatest)(_constants.MS_PAINT_GET_USER_VARIATION, _executors.getUserVariationExecutor);

        case 2:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function postUserVariationWatcher() {
  return _regenerator2.default.wrap(function postUserVariationWatcher$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.takeLatest)(_constants.MS_PAINT_POST_USER_VARIATION, _executors.postUserVariationExecutor);

        case 2:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function getExportListWatcher() {
  return _regenerator2.default.wrap(function getExportListWatcher$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.takeLatest)([_constants.MS_PAINT_GET_EXPORT_LIST, _redux.SESSION_CHANGE_ADVERTISER], _executors.getExportListExecutor);

        case 2:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

function putExportListWatcher() {
  return _regenerator2.default.wrap(function putExportListWatcher$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.takeLatest)(_constants.MS_PAINT_PUT_EXPORT_LIST, _executors.putExportListExecutor);

        case 2:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

function duplicateBlueprintWatcher() {
  return _regenerator2.default.wrap(function duplicateBlueprintWatcher$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.takeLatest)(_constants.MS_PAINT_DUPLICATE_BLUEPRINT, _executors.duplicateBlueprintExecutor);

        case 2:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}

function addCustomMediaAssetWatcher() {
  return _regenerator2.default.wrap(function addCustomMediaAssetWatcher$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.takeLatest)(_constants.MS_PAINT_ADD_CUSTOM_USER_ASSETS, _executors.addCustomMediaAssetExecutor);

        case 2:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked18, this);
}

function startExportJobsPollingWatcher() {
  return _regenerator2.default.wrap(function startExportJobsPollingWatcher$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.takeLatest)([_constants.MS_PAINT_START_EXPORT_JOB_POLLING, _constants.MS_PAINT_POST_VARIATION_SUCCESS, _constants.MS_PAINT_GET_EXPORT_LIST], _executors.exportJobFetchPollerExecutor);

        case 2:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked19, this);
}

var sagas = [currentOrganizationWatcher, fetchAccountsWatcher, uploadMediaToFBWatcher, getBlueprintsWatcher, deleteBlueprintWatcher, getLayerSchemaWatcher, postBlueprintWatcher, putBlueprintWatcher, postLayerTemplatesWatcher, getBlueprintWatcher, postVariationWatcher, postGenerateCSVWatcher, getUserVariationWatcher, postUserVariationWatcher, getExportListWatcher, putExportListWatcher, duplicateBlueprintWatcher, addCustomMediaAssetWatcher, startExportJobsPollingWatcher];

exports.default = sagas;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/store/blueprint/sagas/index.js
// module id = 3919
// module chunks = 5 6 7 8